import axios, { AxiosInstance } from "axios";

const API_DEFAULT_TIMEOUT = 30 * 1000;
const authAuthorityUrl = process.env.REACT_APP_AUTH_AUTHORITY;

export const client: AxiosInstance = axios.create({
  baseURL: authAuthorityUrl,
  timeout: API_DEFAULT_TIMEOUT,
});
